// import shortid from "shortid"
// import seedrandom from "seedrandom"
// import querystring from "query-string"
//
// const query = querystring.parse(window.encounter.search)
// const seed = query.seed || shortid.generate()
//
// seedrandom(seed, {"global": true})
//
// import stage from "@frog/source/data/Stage.js"
//
// if(stage === "development") {
//     console.info("To keep your seed, go to http://127.0.0.1:8080?seed=" + SEED)
// }

export default class Random {
    static sign() {
        return Math.random() < 0.5 ? -1 : +1
    }
    static range(a, b) {
        const min = Math.min(a, b)
        const max = Math.max(a, b)
        return min + (Math.random() * (max - min))
    }
    static element(array) {
        return array[Math.floor(Math.random() * array.length)]
    }
}
